import React  from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap-accordion';

import './styles.scss'
import DataFaqs from '../../assets/fake-data/data-faq';
import { useTranslation } from 'react-i18next';

Faqs2.propTypes = {
    data : PropTypes.array,
};

function Faqs2() {
    const data = DataFaqs();
    const { t } = useTranslation();
    
    return (
        <section className="tf-faq tf-section mt-5">
                <div className="">
                    <div className="col-md-12 ">
                        <div className="tf-heading wow fadeInUp">
                            <h2 className="heading">{t('faq_title')}</h2>
                        </div>
                    </div> 
                   <div className="row justify-content-center">
                        <div className="col-md-8 wow fadeInUp">
                            <div className="tf-flat-accordion2">
                                {
                                    data.map(idx => (
                                        <Accordion show={idx.show} key={idx.id} title={idx.title} className='flat-toggle h6'>
                                            <p className="toggle-content" dangerouslySetInnerHTML={{ __html: idx.text }} />
                                        </Accordion>
                                    ))
                                }
                            </div>
                        </div>
                   </div>
                </div>
            </section>
    );
}

export default Faqs2;